import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useCognitoAuthenticationWithOptions } from '../../../../../shared/services/authentication';
import LoginFields from '../../configs/login_fields.json';
import { useCommon } from './useCommon';
import { AuthLinkComponent } from '../components';
import { ALL_FIELDS_REQUIRED, FORGOT_PASSWORD, LOGIN, REGISTRATION, } from '../constants';
import { UserIdType, } from '../types';
import { localeMapping } from '../../configs/localeMapping';
export function useLoginWithOptions({ defaultInput, onCompleted = () => { }, signinOrRegisterLink, forgotPasswordLink, cognitoUserPoolConfig, userIdType = UserIdType.UserID, browserCacheType = 'localStorage', }) {
    const { handleInputChange, LinkComponent, inputs } = useCommon(defaultInput, REGISTRATION, "Don't have an account?", signinOrRegisterLink);
    const [missingFields, setMissingFields] = useState(false);
    const { authCheckComplete, authToken, authError, authenticateUser, isFetching, } = useCognitoAuthenticationWithOptions({
        cognitoUserPoolConfig,
        browserCacheType,
    });
    const ForgotPasswordComponent = useMemo(() => (React.createElement(AuthLinkComponent, { link: forgotPasswordLink, text: FORGOT_PASSWORD, descp: "", styleClass: "forgot-password-link" })), [forgotPasswordLink]);
    const onSubmit = useCallback(() => {
        const { email, password } = inputs;
        if (email && password) {
            setMissingFields(false);
            authenticateUser(email, password);
            return;
        }
        setMissingFields(true);
    }, [authenticateUser, inputs]);
    useEffect(() => {
        onCompleted({
            authToken,
            authError,
            authCheckComplete,
            userId: inputs.email,
        });
    }, [authToken, authError, authCheckComplete, onCompleted, inputs.email]);
    const loginFormFields = userIdType === UserIdType.UserID
        ? LoginFields.map((field) => {
            if (field.id === 'email')
                return Object.assign(Object.assign({}, field), { placeholder: 'User Name' });
            return Object.assign({}, field);
        })
        : LoginFields;
    return {
        handleInputChange,
        onSubmit,
        formFields: loginFormFields,
        LinkComponent,
        ForgotPasswordComponent,
        authError: missingFields ? ALL_FIELDS_REQUIRED : localeMapping(authError),
        buttonLabel: LOGIN,
        isFetching,
    };
}
export function useLogin(defaultInput, onCompleted, signinOrRegisterLink, forgotPasswordLink, cognitoUserPoolConfig) {
    console.warn("WARNING, depreciated hook use 'useLoginWithOptions' instead.");
    return useLoginWithOptions({
        defaultInput,
        onCompleted,
        signinOrRegisterLink,
        forgotPasswordLink,
        cognitoUserPoolConfig,
    });
}
//# sourceMappingURL=useLogin.js.map